// apps/creativity/src/components/FeedResponseCard.jsx
import { useState } from 'react';
import { CATEGORIES } from '../data/categories';
import { useApp } from '../context/AppContext';
import EmojiPicker from './EmojiPicker';
import styles from './FeedResponseCard.module.css';

function formatDate(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric',
  });
}

function Avatar({ photoURL, displayName }) {
  if (photoURL) {
    return <img src={photoURL} alt={displayName} className={styles.avatar} />;
  }
  return (
    <div className={styles.avatarFallback}>
      {displayName.charAt(0).toUpperCase()}
    </div>
  );
}

export default function FeedResponseCard({ entry, friend, categoryKey, isOwn = false, onPersonClick }) {
  const { dispatch } = useApp();
  const [pickerOpen, setPickerOpen] = useState(false);

  const cat = CATEGORIES.find(c => c.key === categoryKey);
  const data = entry[categoryKey];
  if (!cat || !data?.response) return null;

  const interactions = entry.interactions?.[categoryKey];
  const reactionCounts = interactions?.reactionCounts || {};
  const reactionEntries = Object.entries(reactionCounts).filter(([, n]) => n > 0);
  const replyCount = interactions?.replyCount || 0;
  const latestReply = interactions?.latestReply || null;

  const openDetail = () => {
    dispatch({
      type: 'OPEN_DETAIL',
      detail: {
        ownerUserId: friend.userId,
        entryId: entry.id,
        categoryKey,
        responseText: data.response,
        entryDate: entry.date,
        ownerName: friend.displayName,
        isOwn,
      },
    });
  };

  return (
    <>
      <article
        className={styles.card}
        style={{ '--accent': `var(${cat.accentVar})` }}
        onClick={openDetail}
      >
        <div className={styles.reactionStrip} onClick={e => e.stopPropagation()}>
          {reactionEntries.map(([emoji, count]) => (
            <span key={emoji} className={styles.reactionChip}>
              {emoji} {count}
            </span>
          ))}
          <button
            className={styles.addReactionBtn}
            onClick={e => { e.stopPropagation(); setPickerOpen(true); }}
          >
            +
          </button>
        </div>

        <header className={styles.header}>
          <button className={styles.person} onClick={e => { e.stopPropagation(); onPersonClick(friend.userId); }}>
            <Avatar photoURL={friend.photoURL} displayName={friend.displayName} />
            <span className={styles.name}>{friend.displayName}</span>
          </button>
          <span className={styles.meta}>{formatDate(entry.date)}</span>
        </header>

        <span className={styles.catLabel}>{cat.icon} {cat.label}</span>
        <p className={styles.text}>{data.response}</p>

        {latestReply && (
          <div className={styles.replyPreview}>
            <span className={styles.previewText}>
              "{latestReply.text.length > 60 ? latestReply.text.slice(0, 60) + '…' : latestReply.text}"
              {' '}— {latestReply.authorName} · 💬 {replyCount}
            </span>
          </div>
        )}
      </article>

      {pickerOpen && (
        <EmojiPicker
          ownerUserId={friend.userId}
          entryId={entry.id}
          categoryKey={categoryKey}
          onClose={() => setPickerOpen(false)}
        />
      )}
    </>
  );
}
